import { validate } from 'rut.js';
import { number, object, string } from 'yup';

export const needInvoiceFormSchema = object().shape({
  id: string()
    .required('Este campo es obligatorio.')
    .test('test-rut', 'Por favor, ingresa un RUT válido', (value) =>
      validate(value)
    ),
  officialName: string()
    .required('Este campo es obligatorio.')
    .min(3, 'Por favor, ingresa una razón social válida.'),
  areaOfWork: string()
    .required('Este campo es obligatorio.')
    .min(3, 'Por favor, ingresa un giro válido.'),
  address: string()
    .required('Este campo es obligatorio.')
    .min(3, 'Por favor, ingresa una dirección válida.')
    .max(65, 'La dirección no puede exceder los 65 caracteres.')
    .matches(/^(?=.*[A-Za-z])[A-Za-z\d]/, 'La dirección debe contener letras.'),
  addressNumber: number()
    .transform((_, originalValue) => {
      if (originalValue === '') return null;
      if (/^\d+$/.test(originalValue)) return Number(originalValue);
      return NaN;
    })
    .typeError('Este campo debe ser un número.')
    .required('Este campo es obligatorio.')
    .max(99999999, 'El número no puede tener más de 8 dígitos.')
    .positive('El número de la dirección debe ser un número positivo.')
    .integer('El número de la dirección debe ser un número entero.'),
  numberOfHouseApartmentOrOffice: string().max(
    75,
    'El número de departamento no puede exceder los 75 caracteres.'
  ),
  regionId: string().required('Este campo es obligatorio'),
  communeId: string().required('Este campo es obligatorio')
});

export { yupResolver } from '@hookform/resolvers/yup';
